<template>
  <div class="body">

    <img src="@/assets/chat_bg.jpg" style="width: 100%; height: 100%;position: absolute;z-index: -1" >

    <div class="chat">
      <div class="msg-head">
        <div class="msg-head-item msg-head-item-nickname">{{ chatNickname }}</div>
      </div>
      <div class="msg-body">
        <div class="msg-user msg-user-list">
          <div class="msg-user-item" v-for="(user,i) in historyMessage" :key="i" @click="onShowUserChat(user)">
            <div class="msg-user-item-headImg">
              <div class="demo-image__prediv">
                <el-image
                    style="width: 50px; height: 50px"
                    :src="user.otherinfo.headImage?fileBaseUrl+user.otherinfo.headImage:defaultImg"
                >
                </el-image>
              </div>
            </div>
            <div class="msg-user-item-right">
              <div class="msg-user-item-time">{{user.createdTimeStr}}</div>
              <div class="msg-user-item-nickname">
                <div class="msg-user-item-nickname-left">{{getNickname(user.otherinfo.nickname)}}</div>
                <div class="msg-user-item-nickname-right" v-show="user.count>0">{{user.count}}</div>
              </div>
              <div class="msg-user-item-newmsg">
                <div v-if="user.contentType==='0'">
                  {{getContent(user.content)}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="msg-user msg-user-chat" v-show="showUserChat">
          <div class="msg-user-chat-page">
            <div class="load-more" v-show="!isAll"><span style="color: #0a3435; text-decoration: underline;" @click="loadMore">查看历史消息</span></div>
            <div class="msg-list" v-for="(msg,i) in msgs" :key="i" :id="i===0?'head':(i+1)===msgs.length?'end':''">
              <div class="msg-time" v-if="i===0 || msg.from !== msgs[i-1].from">{{msg.createdTimeStr}}</div>
              <div class="msg-item msg-left" v-if="msg.from!==from">
                <div class="msg-content msg-headImg">
                  <img :src="chatHeadImg" class="avatar" />
                </div>
                <!-- 文本 -->
                <div v-if="msg.contentType==='0'" class="msg-content msg-left-text">
                  {{msg.content}}
                </div>
                <!-- 图片 -->
                <div v-if="msg.contentType==='1'" class="msg-content msg-left-img">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="fileBaseUrl+msg.content"
                        :preview-src-list="[fileBaseUrl+msg.content]">
                    </el-image>
                  </div>
                </div>
                <!-- 视频 -->
                <div v-if="msg.contentType==='2'" class="msg-content msg-left-video">
                  <video controls="controls" :src="fileBaseUrl+msg.content"/>
                </div>
                <!-- 商品 -->
                <div v-if="msg.contentType==='3'" class="msg-content msg-left-product">
                  <message-product :product-str="msg.content" :width="300" :height="100" @click="skipToProduct"></message-product>
                </div>
                <!-- 企业 -->
                <div v-if="msg.contentType==='4'" class="msg-content msg-left-news">
                  <message-news :news-str="msg.content" :width="300" :height="100" @click="skipToNews"></message-news>
                </div>
              </div>
              <div class="msg-item msg-right" v-else>
                <!-- 文本 -->
                <div v-if="msg.contentType==='0'" class="msg-content msg-right-text">
                  {{msg.content}}
                </div>
                <!-- 图片 -->
                <div v-if="msg.contentType==='1'" class="msg-content msg-left-img">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="fileBaseUrl+msg.content"
                        :preview-src-list="[fileBaseUrl+msg.content]">
                    </el-image>
                  </div>
                </div>
                <!-- 视频 -->
                <div v-if="msg.contentType==='2'" class="msg-content msg-left-video">
                  <video controls="controls" :src="fileBaseUrl+msg.content"/>
                </div>
                <div class="msg-content msg-headImg">
                  <img src="@/assets/logo.png" class="avatar" />
                </div>
              </div>
            </div>
          </div>
          <div class="msg-user-chat-input">
            <textarea class="scroll" id="context_text" maxlength="150" wrap="hard" placeholder="请输入..."
                      v-model="content" @keyup.enter="sendMsg"></textarea>
            <div class="msg-send-btn">
              <el-upload
                  style="display: inline-block; margin-right: 10px"
                  :action="fileBaseUrl"
                  :show-file-list="false"
                  :data="uploadData"
                  accept="image/*"
                  :before-upload="imageBeforeUpload"
                  :on-success="imageHandleSuccess"
              >
                <el-button :disabled="!onlineState || isSendMedia" slot="trigger" size="small" type="primary">图片</el-button>
              </el-upload>
              <el-upload
                  style="display: inline-block; margin-right: 10px"
                  :action="fileBaseUrl"
                  :show-file-list="false"
                  :data="uploadData"
                  accept="video/*"
                  :before-upload="videoBeforeUpload"
                  :on-success="videoHandleSuccess"
              >
                <el-button :disabled="!onlineState || isSendMedia" slot="trigger" size="small" type="primary">视频</el-button>
              </el-upload>
              <el-button type="primary" @click="sendMsg" :disabled="!onlineState || !content">发送</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {ChatRequestMessage} from "@/views/CustomerMessageManage/messages/request/RequestMessage";
import getFromMessage from "@/api/chat/getFromMessage";
import readMessage from "@/api/chat/readMessage";
import {online, sendMsg} from "@/utils/websocket/websocket";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import MessageProduct from "@/components/MessageProduct/MessageProduct.vue";
import MessageNews from "@/components/MessageNews/MessageNews.vue";

export default {
  name: "CustomerMessageManage",
  components: {MessageNews, MessageProduct},
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      defaultImg: 'https://thirdwx.qlogo.cn/mmopen/vi_32/POgEwh4mIHO4nibH0KlMECNjjGxQUq24ZEaGT4poC6icRiccVGKSyXwibcPq4BWmiaIGuG1icwxaQX6grC9VemZoJ8rg/132',
      chatNickname: '',
      chatHeadImg: '',
      showUserChat: false,
      from: 'agency,' + JSON.parse(localStorage.getItem('userinfo')).id,
      msgs: [],

      to: '',
      content: '',

      isAll: false,

      uploadData: {  //提交到OSS的参数
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
      },
      isSendMedia: false,
    }
  },
  watch: {
    'msgs': {
      handler() {
        if (this.isPositionEnd) {
          this.positionEnd()
        } else {
          this.positionHead()
        }
        this.clearCount()
      },
    },
    'historyMessageStr': {
      handler() {
        this.updateMsgs()
      }
    },
    historyMessage: {
      deep: true,
      handler() {
        if (this.showUserChat && this.to) {
          this.updateMsgs()
        }
      }
    },
  },
  computed: {
    ...mapGetters(['historyMessage', 'historyMessageStr', 'isPositionEnd', 'onlineState', 'socket']),
  },
  methods: {
    ...mapActions({
      setSocket: 'setSocket',
      setOnlineState: 'setOnlineState',
      setOnlineDisabled: 'setOnlineDisabled',
      setAutoReconnect: 'setAutoReconnect',
      clearHistoryMessage: 'clearHistoryMessage',
      save_to_storage: 'save_to_storage',
      openPositionEnd: 'openPositionEnd',
      closePositionEnd: 'closePositionEnd',
      addToHistoryMessage: 'addToHistoryMessage',
    }),


    skipToProduct(product){
      console.log(product)
      localStorage.setItem('storeTypeId',product.typeId)
      // localStorage.setItem('storeUserType','0')
      // localStorage.setItem('productId',product.id)
      this.$router.push({
        name: "商品管理",
        params: {
          productId: product.id,
        }
      })
    },
    skipToNews(news){
      console.log(news)
      this.$router.push({
        name: "企业管理",
        params: {
          id: news.id,
        }
      })
    },
    async imageBeforeUpload(file) {
      if (this.isSendMedia) return false
      console.log(file)
      let types = new Set()
      types.add('image/jpeg')
      types.add('image/png')
      types.add('image/gif')
      types.add('image/webp')


      const size = file.size
      const maxSize = 1024 * 1024 * 5
      if (size > maxSize) {
        this.$message.error('图片大小不能超过5MB!');
        return false
      }
      if (!types.has(file.type)) {
        this.$message.error('请上传图片格式!');
        return false
      } else {
        this.isSendMedia = true
        this.$message({
          message: '发送中...',
          type: 'warning'
        });
        await getAliyunOssSign("/common/sign").then(response => {
          //设置相关的参数
          let resultObj = response.data;
          this.uploadData.policy = resultObj.policy;
          this.uploadData.signature = resultObj.signature;
          this.uploadData.ossaccessKeyId = resultObj.accessid;
          //上传的文件名，使用UUID处理一下
          this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
          this.uploadData.dir = resultObj.dir;
          this.uploadData.host = resultObj.host;
        });
        return true
      }
    },
    imageHandleSuccess(response, file) {
      let source = this.uploadData.key.replace("${filename}", file.name)
      this.sendImage("/" + source)
    },
    async videoBeforeUpload(file) {
      if (this.isSendMedia) return false
      console.log(file)
      let types = new Set()
      types.add('video/mp4')

      const size = file.size
      const maxSize = 1024 * 1024 * 100
      if (size > maxSize) {
        this.$message.error('视频大小不能超过100MB!');
        return false
      }
      if (!types.has(file.type)) {
        this.$message.error('请上传视频格式!');
        return false
      } else {
        this.isSendMedia = true
        this.$message({
          message: '发送中...',
          type: 'warning'
        });
        await getAliyunOssSign("/common/sign").then(response => {
          //设置相关的参数
          let resultObj = response.data;
          this.uploadData.policy = resultObj.policy;
          this.uploadData.signature = resultObj.signature;
          this.uploadData.ossaccessKeyId = resultObj.accessid;
          //上传的文件名，使用UUID处理一下
          this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
          this.uploadData.dir = resultObj.dir;
          this.uploadData.host = resultObj.host;
        });
        return true
      }
    },
    videoHandleSuccess(response, file) {
      let source = this.uploadData.key.replace("${filename}", file.name)
      this.sendVideo("/" + source)
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    clearCount() {
      let froms = this.to.split(',')
      let fromType = froms[0]
      let fromId = froms[1]
      //将状态全部设置成已读
      let readState = '是'
      for (let i = 0; i < this.msgs.length; i++) {
        if (this.msgs[i].from != this.from && this.msgs[i].readState == '否') readState = '否'
      }
      if (readState === '否') {
        readMessage(fromType, fromId)
      }
      const findResult = this.historyMessage.find(x => x.fromType == fromType && x.fromId == fromId)
      if (findResult) {
        //将count清空
        findResult.count = 0
        this.save_to_storage()
      }
    },
    positionHead() {
      setTimeout(() => {
        this.openPositionEnd()
        let target = document.getElementById("head")
        if (!target) return
        console.log('滚动到head: ', target)
        target.scrollIntoView({behavior: 'smooth'}); // 滚动到目标元素
      }, 100)
    },
    positionEnd() {
      setTimeout(() => {
        let target = document.getElementById("end")
        if (!target) return
        console.log('滚动到end: ', target)
        target.scrollIntoView({behavior: 'smooth'}); // 滚动到目标元素
      }, 100)
    },
    updateMsgs() {
      let froms = this.to.split(',')
      let fromType = froms[0]
      let fromId = froms[1]
      const findResult = this.historyMessage.find(x => x.fromType == fromType && x.fromId == fromId)
      if (findResult) {
        this.isAll = findResult.isAll
        this.msgs = findResult.msgs
        //将count清空
        findResult.count = 0
        this.save_to_storage()
      }
    },
    loadMore() {
      this.closePositionEnd()
      let froms = this.to.split(',')
      let fromType = froms[0]
      let fromId = froms[1]
      const findResult = this.historyMessage.find(x => x.fromType == fromType && x.fromId == fromId)
      let createdTime = undefined
      if (findResult) createdTime = findResult.createdTime
      else createdTime = new Date().getTime()
      getFromMessage(fromType, fromId, createdTime).then(res => {
        let data = res.data
        for (let i = data.length - 1; i >= 0; i--) {
          this.addToHistoryMessage(data[i])
        }
        this.updateMsgs()
        if (data.length < 20) {
          this.isAll = true
          if (findResult) findResult.isAll = true
          this.save_to_storage()
        }
      })
    },
    sendImage(content) {
      console.log('发送文件: ', content)
      let chatRequestMessage = new ChatRequestMessage(this.to, content, '1','COMMON')
      sendMsg(chatRequestMessage)
      this.isSendMedia = false
    },
    sendVideo(content) {
      console.log('发送文件: ', content)
      let chatRequestMessage = new ChatRequestMessage(this.to, content, '2','COMMON')
      sendMsg(chatRequestMessage)
      this.isSendMedia = false
    },
    sendMsg() {
      if (!this.onlineState || !this.content) return
      let chatRequestMessage = new ChatRequestMessage(this.to, this.content, '0','COMMON')
      sendMsg(chatRequestMessage)
      this.content = ''
    },
    onShowUserChat(user) {
      this.showUserChat = true
      this.chatNickname = user.otherinfo.nickname
      this.chatHeadImg = user.otherinfo.headImage ? this.fileBaseUrl + user.otherinfo.headImage : this.defaultImg
      this.msgs = user.msgs
      this.to = user.fromType + ',' + user.fromId
      this.isAll = user.isAll
    },
    getNickname(nickname) {
      if (!nickname) return '用户未填写昵称'
      if (nickname.length > 10) return nickname.substring(0, 8) + '...'
      return nickname
    },
    getContent(content) {
      if (content.length > 10) return content.substring(0, 8) + '...'
      return content
    },
  },

  mounted() {
    localStorage.removeItem('historyMessage')
    this.setAutoReconnect(true)
    online(this, this.socket)
  },
}
</script>

<style lang="scss" scoped>
@import "css/CustomerMessageManage";
</style>
